import axiosInstance from '../axiosInstance';

// Obtener todos los tipos de comprobante
export const fetchCurrencieTypes = async () => {
  const response = await axiosInstance.get('/accounting/currencieType');
  return response.data;
};

// Crear un nuevo tipo de comprobante
export const createCurrencieType = async (data) => {
  const response = await axiosInstance.post('/accounting/currencieType', data);
  return response.data;
};

// Actualizar un tipo de comprobante
/*export const updateComprobanteType = async (id, data) => {
  const response = await axiosInstance.put(`/accounting/currencieType/${id}`, data);
  return response.data;
};*/

// Eliminar un tipo de comprobante
/*export const deleteComprobanteType = async (id) => {
  const response = await axiosInstance.delete(`/accounting/currencieType/${id}`);
  return response.data;
};*/
